/* Raw Form lazy video (the How to use clip, sections/rf-howto.liquid).

   Nothing is requested until the clip is nearly in view: no poster, no
   video. Then it loads the phone-sized file on a narrow screen, the full one
   otherwise, plays muted on a loop, and pauses again once it scrolls away.

   Anyone who asked for reduced motion, or whose browser reports Data Saver,
   gets the still only. */
class RFLazyVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video || !this.dataset.src) return;
    this.small = window.matchMedia('(max-width: 820px)').matches;

    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => (e.isIntersecting ? this.load() : this.pause())),
      { rootMargin: '300px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  stillOnly() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    const net = navigator.connection;
    return !!(net && net.saveData);
  }

  load() {
    if (!this.loaded) {
      this.loaded = true;
      const poster = (this.small && this.dataset.posterSm) || this.dataset.poster;
      if (poster) this.video.poster = poster;
      if (this.stillOnly()) {
        this.observer && this.observer.disconnect();
        return;
      }
      this.video.src = (this.small && this.dataset.srcSm) || this.dataset.src;
      this.playing = true;
    }
    if (!this.playing) return;
    /* Autoplay can still be refused; the still stays up if it is. */
    const p = this.video.play();
    if (p && p.catch) p.catch(() => {});
  }

  pause() {
    if (this.playing && !this.video.paused) this.video.pause();
  }
}

if (!customElements.get('rf-lazy-video')) customElements.define('rf-lazy-video', RFLazyVideo);
